import {CRecordClass, ChildPath} from 'app/modules/discovery/core/newmodels/_base'
import {AxiosRequestConfig} from 'axios'

export class ParentContext {
  parent
  child
  prop
  path
  reverse

  constructor(args: {
    parentClass: CRecordClass
    childClass: CRecordClass
    parentId: string
    childId?: string
    prop?: string
  }) {
    const {parentClass, childClass, parentId, childId, prop} = args

    let path: ChildPath | undefined = undefined
    if (prop) {
      path = parentClass.childPath(prop)
    } else {
      let matched = false
      for (const childPath of parentClass.childPaths) {
        if (childPath.childClass === childClass) {
          if (matched) {
            throw new Error(
              `ParentContext({ parentClass: ${parentClass.name}, childClass: ${childClass.name} }) found multiple options for the parent-child relationship. Specify "prop" to distinguish them.`
            )
          }
          path = childPath
          matched = true
        }
      }
      if (!path) {
        throw new Error(
          `ParentContext({ parentClass: ${parentClass.name}, childClass: ${childClass.name} }) found no options for the parent-child relationship.`
        )
      }
    }
    if (!path) {
      throw new Error(`Path not found.`)
    }
    this.parent = {
      recordClass: parentClass,
      id: parentId,
    }
    this.child = {
      recordClass: childClass,
      id: childId,
    }
    this.prop = path.prop
    this.reverse = path.reverse
    this.path = path
  }

  get contextId() {
    return `${this.parent.recordClass.name}.${this.prop}/${this.parent.id}/${this.child.id}`
  }

  get debug() {
    return `ParentContext[\n  parent: ${this.parent.recordClass.name} ${this.parent.id}\n  child: ${
      this.child.recordClass.name
    } ${this.child.id ?? '<no id>'}\n  prop: ${this.prop}\n]`
  }

  get axiosConfig(): AxiosRequestConfig {
    if (this.parent.recordClass.external_id === 'project_id') {
      return {headers: {'x-project-unique-id': this.parent.id}}
    }
    if (this.parent.recordClass.external_id === 'tenant_id') {
      return {headers: {'x-tenant-unique-id': this.parent.id}}
    }
    return {}
  }
}
